import Card from "./Card";
import { data } from "./data.js";
import { motion } from "framer-motion";

export const TopCMSPlatforms = () => {
  return (
    <section className="   space-y-14 ">
      <div className="lg:text-center space-y-5 ">
        <div className=" mx-auto md:w-11/12 lg:w-10/12 xl:w-9/12  ">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px] text-center  font-bold text-dark font-butler"
          >
            A Comparison of Top CMS Platforms to Grow Your Brand Online{" "}
          </motion.h2>
        </div>
        <p className="text-base leading-[1.625rem] text-center text-dark ">
          Choosing the right foundation is critical for your digital strategy.
          We've vetted the strengths of top-performing systems to help you
          identify which solution offers the best balance for your specific
          requirements and long-term use-case.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-1  lg:grid-cols-2  gap-10 md:gap-8 lg:gap-10 ">
        {data.map((content, i) => (
          <Card
            img={content.img}
            altText={content.altText}
            mainHeading={content.mainHeading}
            subHeading={content.subHeading}
            bulletPoints={content.bulletPoints}
          />
        ))}
      </div>
    </section>
  );
};
